import {
  getDate,
  getHours,
  getMinutes,
  getMonth,
  getYear,
  isValid,
  parseISO,
  set,
} from "date-fns";

export const findPracticeHoursRange = (scheduleData) => {
  const allHours = scheduleData.result.flatMap((day) => day.doctors);

  if (allHours.length === 0) {
    return null;
  }

  const parsedHours = allHours.map((doctor) => ({
    start: parseISO(doctor.practiceHours.start),
    end: parseISO(doctor.practiceHours.end),
  }));

  if (parsedHours.some(({ start, end }) => !isValid(start) || !isValid(end))) {
    throw new Error("Invalid date format found in practice hours");
  }

  // Use the first day as the base date for normalisation.
  const baseDate = parsedHours[0].start;

  // Compare times-of-day only so that e.g. Tue 08:00 beats Mon 09:00 as
  // the earliest start, regardless of which calendar day comes first.
  const toMinutes = (date) => getHours(date) * 60 + getMinutes(date);

  const { earliestStartMinutes, latestEndMinutes } = parsedHours.reduce(
    (acc, { start, end }) => ({
      earliestStartMinutes: Math.min(acc.earliestStartMinutes, toMinutes(start)),
      latestEndMinutes: Math.max(acc.latestEndMinutes, toMinutes(end)),
    }),
    { earliestStartMinutes: Infinity, latestEndMinutes: -Infinity }
  );

  const earliestStart = set(baseDate, {
    hours: Math.floor(earliestStartMinutes / 60),
    minutes: earliestStartMinutes % 60,
    seconds: 0,
    milliseconds: 0,
  });

  const latestEnd = set(baseDate, {
    hours: Math.floor(latestEndMinutes / 60),
    minutes: latestEndMinutes % 60,
    seconds: 0,
    milliseconds: 0,
  });

  // Ensure both bounds are on the same calendar day.
  const adjustedLatestEnd = set(latestEnd, {
    year: getYear(earliestStart),
    month: getMonth(earliestStart),
    date: getDate(earliestStart),
  });

  return {
    earliestStart,
    latestEnd: adjustedLatestEnd,
  };
};
